module.exports = __webpack_public_path__ + "static/frendli_logo_square_300x300-58ec2e01df30453c7c3e01d13cd65ee4.jpg";